import React from 'react';

const PaymentTerms = () => {
  return (
    <>
      <div className="mt-10 border-t pt-6 text-sm text-gray-600">
        <p className="font-bold mb-2">Payment Terms:</p>
        <p>Please make all payments within 5 days of the invoice date. Accepted payment methods include bank transfer, check, and major credit cards.</p>
      </div>

      <div className="mt-10 text-center text-sm text-gray-500">
        <p>Thank you for your business!</p>
      </div>
    </>
  );
};

export default PaymentTerms;